import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MyChartsService } from '@app/core/features/charts-manager/my-charts/my-charts.service';
import { UpdateChartCustomNamePayload } from '@app/core/features/charts-manager/my-charts/transfer-charts';
import { TransferChartsService } from '@app/core/features/charts-manager/my-charts/transfer-charts/transfer-charts.services';
import { getRandomNumber } from '@app/utils';

@Component({
  selector: 'app-edit-chart-custom-name-dialog',
  templateUrl: './edit-chart-custom-name-dialog.component.html',
  styleUrls: ['./edit-chart-custom-name-dialog.component.scss']
})
export class EditChartCustomNameDialogComponent implements OnInit {
  chartCustomName: string;
  listChartEntitlementId: string[];

  constructor(
    public dialogRef: MatDialogRef<EditChartCustomNameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public transferChartService: TransferChartsService,
    public myChartsService: MyChartsService
  ) { }

  ngOnInit() {
    const { data: { chartCustomName, listChildChartEntitlementId } } = this;
    this.chartCustomName = chartCustomName;
    this.listChartEntitlementId = listChildChartEntitlementId;
  }

  editChartCustomName() {
    const payload: UpdateChartCustomNamePayload = {
      chartEntitlementIds: this.listChartEntitlementId,
      chartCustomName: this.chartCustomName
    };

    this.transferChartService.updateChartCustomName(payload).subscribe(res => {
      if (res === true) {
        this.myChartsService.checkChangedMyListCharts.next(getRandomNumber());
        this.dialogRef.close();
      }
    });
  }

  cancel() {
    this.dialogRef.close();
  }

}
